import * as RadixUiSeparator from "@radix-ui/react-separator";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

const classNamePrefix = "Separator";

type SeparatorProps = Omit<RadixUiSeparator.SeparatorProps, "children"> & {
  variant: "empty" | "or";
};

export const Separator = React.forwardRef(
  (props: SeparatorProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const { className, variant, ...restProps } = props;

    const { t } = useTranslation();
    const { text } = t("features.shared.Separator", { variant }) as unknown as {
      text: string;
    };

    return (
      <RadixUiSeparator.Root
        ref={ref}
        {...restProps}
        className={classNames(className, classNamePrefix)}
        data-variant={variant}
      >
        {text && <div>{text}</div>}
      </RadixUiSeparator.Root>
    );
  },
);
